var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-0 mx--1"},[_c('drop-zone',{ref:"parentDropZone",attrs:{"objectId":_vm.objectId,"media":_vm.media,"collectionDBname":_vm.collectionDBname,"photos":_vm.photos,"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }